import { Button, Card, Col, Divider, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../../store/hooks';
import { openModal } from '../../../ui/store/ui-slice';
import { useGetUserQuery } from '../../api/user-api';
import { currentUserEmailFormModalId, currentUserFormModalId } from '../../constants/constants';
import { setActiveCurrentUserId } from '../../store/current-user-slice';
import CurrentUserFormModal from '../current-user-edit-modal/current-user-edit-modal';
import CurrentUserEmailFormModal from '../current-user-email-edit-modal/current-user-email-edit-modal';
import styles from './current-user-information-card.module.css';

const CurrentUserInformationCard = (): JSX.Element => {
  const { data: currentUser } = useGetUserQuery();
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['current-user', 'common']);

  const handleOpenEditModal = (modalId: string) => {
    if (currentUser?.id) {
      dispatch(openModal(modalId));
      dispatch(setActiveCurrentUserId(currentUser.id));
    }
  };

  return (
    <Card title={t('userInfo.accountInfo')}>
      <Row gutter={16} justify="space-between">
        <Col span={6}>{t('label.domain', { ns: 'common' })}</Col>
        <Col span={6}>{currentUser?.domain}</Col>
        <Col span={12}></Col>
      </Row>
      <Divider />
      <Row gutter={16}>
        <Col span={6} className={styles.userInformationColumn}>
          {t('userInfo.fullName')}
        </Col>
        <Col span={6} className={styles.userInformationColumn}>
          {currentUser?.name}
        </Col>
        <Col span={12}>
          <Row justify="end">
            <Col>
              <Button type="primary" onClick={() => handleOpenEditModal(currentUserFormModalId)}>
                {t('action.edit', { ns: 'common' })}
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider />
      <Row gutter={16} justify="space-between">
        <Col span={6}>{t('label.username', { ns: 'common' })}</Col>
        <Col span={6}>{currentUser?.username}</Col>
        <Col span={12}></Col>
      </Row>
      <Divider />
      <Row gutter={16} justify="space-between">
        <Col span={6} className={styles.userInformationColumn}>
          {t('label.email', { ns: 'common' })}
        </Col>
        <Col span={6} className={styles.userInformationColumn}>
          {currentUser?.email}
        </Col>
        <Col span={12}>
          <Row justify="end">
            <Col>
              <Button type="primary" onClick={() => handleOpenEditModal(currentUserEmailFormModalId)}>
                {t('action.edit', { ns: 'common' })}
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <CurrentUserFormModal />
      <CurrentUserEmailFormModal />
    </Card>
  );
};

export default CurrentUserInformationCard;
